import { createContextualCan } from '@casl/react';
import { createContext } from 'react';
import { ability } from './ability';

export const AbilityContext = createContext(ability);
export const Can = createContextualCan(AbilityContext.Consumer);
